module.exports = __webpack_public_path__ + "static/img/img-3.4edf63c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-3.png
// module id = UwRL
// module chunks = 1